<template>
    <el-dialog :title="$t('Approve.ApproverChoose')" :visible.sync="shows" width="680px" height="500px" append-to-body
        @close="close">
        <div class="_steps_checkbox">
            <div class="_steps_item">
                <el-checkbox-group v-model="values" @change="GetChange" :max="20">
                    <div class="_line" v-for="(item, idx) in userlist" :key="idx">
                        <el-checkbox :label="item.UserID">
                            {{ item.UserName }}
                        </el-checkbox>
                    </div>
                </el-checkbox-group>
            </div>
            <div class="_steps_item1">
                <div class="_steps_user" v-for="(item, index) in checkList" :key="index">
                    {{ item.UserName }}
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">{{ $t('AssetListAdd.quit') }}</el-button>
            <el-button type="primary" @click="submit">{{ $t('AssetListAdd.query') }}</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean
        },
        list: {
            type: Array
        },
        checklist: {
            type: Array
        }
    },
    data() {
        return {
            userlist: [],
            showlist: [],
            shows: false,
            values: [],
            checkList: []
        }
    },
    mounted() {
        this.userlist = JSON.parse(JSON.stringify(this.list));
        this.checkList = JSON.parse(JSON.stringify(this.checklist));
        this.values = this.checkList.map(val => {
            return val.UserID;
        })
        this.shows = this.show;
    },
    methods: {
        GetChange(e) {
            let list = [];
            for (let item of this.userlist) {
                if (e.filter(val => val == item.UserID).length) {
                    list.push(item);
                }
            }
            this.checkList = list;
        },
        submit() {
            this.$emit('submit', this.checkList);
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>
<style lang="scss" scoped>
._steps_checkbox {
    width: 100%;
    display: flex;

    ._line {
        padding: 2px 5px;
    }

    ._steps_item {
        height: 150px;
        overflow-y: auto;
        flex: 2;
    }

    ._steps_item1 {
        flex: 5;
        height: 150px;
        border: 1.5px dashed #ccc;
        overflow-y: auto;

        ._steps_user {
            display: inline-block;
            padding: 5px;
            background-color: #f7f7f7;
            border-radius: 4px;
            margin: 5px;
        }
    }

}
</style>